module.exports = "/_next/static/images/slide6-5089c3e1a07c3c2167f177b2232132f6.webp";